export function CreateFonts() {
    return {
        main:  'system-ui,-apple-system,sans-serif',
        serif: 'serif',
        mono:  'monospace',
        sans:  'sans-serif',
    }
};
